import ShareableLinkWaitingRoom from './ShareableLinkWaitingRoom.component';

export default ShareableLinkWaitingRoom;